// @ts-nocheck
import { RECENT_LOGS_FAILURE, RECENT_LOGS_REQUEST, RECENT_LOGS_SUCCESS } from "../constants/logs";

const initialState = {
    recentLogs: {
        data: [],
        isLoading: false,
        dataLoadedOnce: false
    }
};

const logsReducer = (state = initialState, action) => {
    switch (action?.type) {
        case RECENT_LOGS_REQUEST: 
            return {
                ...state,
                recentLogs: {
                    ...state?.recentLogs,
                    isLoading: true
                }
            }

        case RECENT_LOGS_SUCCESS: 
            return {
                ...state,
                recentLogs: {
                    ...state?.recentLogs,
                    data: action?.payload?.recentLogs,
                    isLoading: false,
                    dataLoadedOnce: true
                }
                
            }

        case RECENT_LOGS_FAILURE: 
            return {
                ...state,
                recentLogs: {
                    ...state?.recentLogs,
                    isLoading: false
                }
            }

        default:
            return state;
    }
};

export default logsReducer;
export {
    initialState
}